import { DateService } from '../services/date-service';

/**
 * `lastRefreshedAt` carries a C# `DateTime.MinValue` sentinel when a connection has never synced, so it
 * must be recognised rather than rendered as 1/1/0001. `DateService.isEmptyDate` already answers exactly
 * that question — and treats an absent or unparseable value the same way — so this is a wrapper that
 * gives the inventory-sync code a name for the sentinel, not a second implementation of it.
 */
export const isMinDate = (timestamp: string | null | undefined): boolean => Boolean(DateService.isEmptyDate(timestamp));

/** Collapses the sentinel to `null` so callers can render their own "never synced" copy. */
export const toDisplayableTimestamp = (timestamp: string | null | undefined): string | null =>
  isMinDate(timestamp) ? null : (timestamp ?? null);
